import React, { SyntheticEvent, FunctionComponent } from 'react';
import Close from 'dibs-icons/exports/Close';
import classnames from 'classnames';

import styles from './main.scss';

type ModalCloseButtonProps = {
    dataTn?: string;
    onClick: (e: SyntheticEvent<HTMLElement>) => void;
    className?: string;
    disabled?: boolean;
    backgroundColor?: string;
};

export const ModalCloseButton: FunctionComponent<ModalCloseButtonProps> = props => {
    const { className, dataTn, onClick, disabled, backgroundColor = 'transparent' } = props;

    let bgColorClass = backgroundColor;
    if (backgroundColor === 'transluscentWhite') {
        bgColorClass = styles.transluscentWhite;
    }

    const wrapperClass = classnames(styles.closeClickableArea, className, {
        [styles.closeButtonDisabled]: disabled,
        [bgColorClass]: !!backgroundColor,
    });

    return (
        <div
            data-tn={dataTn || 'modal-close-button'}
            className={wrapperClass}
            onClick={disabled ? () => {} : onClick}
        >
            <div className={styles.closeIcon}>
                <Close />
            </div>
        </div>
    );
};
